// Single source for onboarding asset URLs.
const ASSET_BASE = 'https://media.meetball.fun';

// On the CDN (images/onboarding, videos/onboarding).
export const ONBOARDING_HERO_MP4 = `${ASSET_BASE}/videos/onboarding/onboarding-hero.mp4`;
export const ONBOARDING_HERO_POSTER = `${ASSET_BASE}/images/onboarding/onboarding-hero-poster.webp`;
export const AVATAR_MABEL = `${ASSET_BASE}/images/onboarding/avatar-1.png`;
export const AVATAR_MIRA = `${ASSET_BASE}/images/onboarding/mira.png`;
export const AVATAR_MIGUEL = `${ASSET_BASE}/images/onboarding/miguel-avatar.png`;
export const LOGO_WHITE = `${ASSET_BASE}/images/onboarding/meetball_logo_white.svg`;
export const LOGO_TEXT = `${ASSET_BASE}/images/onboarding/meetball_logo_text.svg`;

// Kept local (still bundled — shared with V1 / app-wide).
export const HELP_ICON = '/assets/space-welcome/welcome_v2_icanhelp_icon.svg';
export const HELP_AVATAR = '/assets/space-welcome/welcome_v2_avatar.png';
export const HELP_AVATAR_2 = '/assets/space-welcome/emanuele.png';

/**
 * The app-wide logo that ships in `public/`, used as the fallback when the CDN
 * logos above fail to load. Bundled deliberately: a fallback that is itself a
 * remote URL can rot the same way the thing it replaces did, and this is the
 * first screen a new user sees.
 */
export const BUNDLED_LOGO = '/Meetball Logo.svg';
